import { render, staticRenderFns } from "./PackagePaymentModal.vue?vue&type=template&id=36f61533&scoped=true"
import script from "./PackagePaymentModal.vue?vue&type=script&lang=ts"
export * from "./PackagePaymentModal.vue?vue&type=script&lang=ts"
import style0 from "./PackagePaymentModal.vue?vue&type=style&index=0&id=36f61533&prod&scoped=true&lang=css"
import style1 from "./PackagePaymentModal.vue?vue&type=style&index=1&id=36f61533&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f61533",
  null
  
)

export default component.exports